import { WidgetDataSource } from '../../../../../models';
import { Report } from '../../../../../providers/storage-api/report.service';
import { AbstractChartReport } from '../chart-report-abstract/chart-report-abstract';

export interface SentimentAccuracyDataItem {
  sentiment: string;
  accuracy: number;
  total: number;
  correct: number;
  unknown?: number;
}

export interface SentimentAccuracyData {
  data: SentimentAccuracyDataItem[];
  summary: SentimentAccuracyDataItem;
}

export class SentimentAccuracyChartReport extends AbstractChartReport {
  public static OVERALL = 'OVERALL';

  reportName = 'docSentimentAccuracy';
  fieldStatisticsReportName = 'fieldStatistics';

  reportHandler = (_dashboard, _widget, _response, _options) => {
    return {};
  };

  getFields() {
    return [];
  }

  getOptionalFields() {
    return [];
  }

  public canHideItems(): boolean {
    return false;
  }

  public canDrilldown() {
    return false;
  }

  public canSort() {
    return false;
  }

  public canSetChartMaximum(): boolean {
    return false;
  }

  public async executeReportForSentimentAccuracy(
    filterQuery: string,
    analyticItem: string,
    widgetDataSource: WidgetDataSource,
    format: 'json' | 'csv' = 'json'
  ): Promise<SentimentAccuracyData> {
    const params = await this.getParams();
    params.analysisName = widgetDataSource.analysisId;

    params.customField = analyticItem;

    const response = (await this.reportService.getReport(
      widgetDataSource.collectionName,
      widgetDataSource.groupId,
      this.reportName,
      params,
      format,
      filterQuery,
      this.filterService.buildFilterStringClearPolarityFilters(this.options.filters, analyticItem),
      undefined,
      this.options.projectId
    )) as Report<{ [p: string]: any }>;

    this.lastDocumentCount = response.totalHits;

    return this.processResponse(response.items);
  }

  public async processResponse(report, _filterQuery?: string): Promise<SentimentAccuracyData> {
    const data = [];

    if (!Object.keys(report).length) {
      return { data, summary: undefined };
    }

    for (const row of Object.keys(report)) {
      if (row === SentimentAccuracyChartReport.OVERALL) {
        continue;
      }
      data.push({
        sentiment: row,
        ...report[row],
      });
    }

    return { data, summary: report[SentimentAccuracyChartReport.OVERALL] };
  }
}
